export const ME = (state, data) => {
  state.user = data;
  state.loggedIn = true;
};

export const LOGOUT = (state) => {
  state.user = {};
  state.loggedIn = false;
};
